// Consultation/ConsultationConfigsPicker.tsx

import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ConsultationConfigCard from 'Consultation/ConsultationConfigCard';
import {Controller} from 'react-hook-form';
import {Typography} from '@mui/material';
import {fetchPsychologyParams} from "Redux/psychologyParamsSlice";
import {AppDispatch, RootState} from "Redux/store";
import {FR} from "WideLayout/Layouts";
import {IConsultationConfig} from "../../Types/psychology/consultation";

interface ConsultationConfigsPickerProps {
    control: any;
}

const ConsultationConfigsPicker: React.FC<ConsultationConfigsPickerProps> = ({control}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {consultation_configs, status} = useSelector(
        (state: RootState) => state.psychologyParams
    );

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchPsychologyParams());
        }
    }, [status, dispatch]);

    if (status === 'loading') {
        return <Typography>Загрузка конфигураций консультаций...</Typography>;
    }

    if (status === 'failed') {
        return (
            <Typography color="error">Ошибка загрузки конфигураций консультаций</Typography>
        );
    }

    return (
        <Controller
            name="consultation_configs"
            control={control}
            render={({field}) => (
                <FR wrap g={1}>
                    {consultation_configs.map((config: IConsultationConfig) => {
                        const isSelected = field.value.includes(config.id);
                        return (
                            <ConsultationConfigCard
                                key={config.id}
                                config={config}
                                selected={isSelected}
                                onClick={(id) => {
                                    if (isSelected) {
                                        field.onChange(field.value.filter((selectedId: number) => selectedId !== id));
                                    } else {
                                        field.onChange([...field.value, id]);
                                    }
                                }}
                            />
                        );
                    })}
                </FR>
            )}
        />
    );
};

export default ConsultationConfigsPicker;
